(function () {
    'use strict';

    angular.module('Services').factory('P2PJobsTableService', P2PJobsTableService);
    P2PJobsTableService.$inject = [
        'FleetService',
        'ClientService',
        'TableLiteFactory',
        'toastr',
        '$q',
        'TypeStatusConsts',
        'Units',
        'ConfirmationModalFactory',
        '$rootScope',
        '$filter',
        '$uibModal',
        'ScanSummaryHelperService'
    ];


    function P2PJobsTableService(
        FleetService,
        ClientService,
        TableLiteFactory,
        toastr,
        $q,
        TypeStatusConsts,
        Units,
        ConfirmationModalFactory,
        $rootScope,
        $filter, 
        $uibModal,
        ScanSummaryHelperService
    ) {
        return function (params, loadUnassignedByDefault = false, showAssignButton = false) {
            
            const { jobType, jobTypeValue, jobStatuses, jobStatusesValue } = TypeStatusConsts;
            const approveJobConfirmation = new ConfirmationModalFactory({}, {
                message: 'messages.warning.approveJob.MESSAGE',
                code: 'messages.warning.approveJob.CODE',
            });

            let viewConfirmation = new ConfirmationModalFactory({}, {
                message: 'messages.warning.archive.MESSAGE',
                code: 'messages.warning.archive.CODE',
            });

            let tableData = {
                tableName: 'JobsTable',
                optionAddOns: {
                    buttons: params.disableAdding ? null : [{
                        class: 'btn-primary',
                        label: 'APPROVE SELECTED',
                        onClick: function () {
                            const selectedForApprovalJobs = tableData.data.filter(job => job.isSelected === true);
                            const vm = this;
                            if (selectedForApprovalJobs.length) {
                                approveJobConfirmation.getInstance().result.then(cond => {
                                    if (cond) {
                                        vm.disabled = true;
                                        FleetService.Jobs.updateStatus(selectedForApprovalJobs.map(job => job.id),
                                            { toStatus: 'PENDING', remarks: 'Approved' },
                                            () => {
                                                toastr.success('Successfully Approved selected jobs');
                                                tableActions.sendRequest({});
                                                vm.disabled = false;
                                            },
                                            error => {
                                                toastr.error('Unable to Approve selected jobs', error.message);
                                                vm.disabled = false;
                                            });
                                    }
                                });
                                return null;
                            }
                            toastr.info('No `For Approval` jobs selected');
                        }
                    }, {
                        class: 'btn-success',
                        label: 'ARCHIVE',
                        onClick:()=>{
                            const vm = this;
                            const selectedForArchiveJobs = tableData.data.filter(job => job.isSelected === true);
                            if(!selectedForArchiveJobs.length){
                                toastr.info('No jobs selected to move in archives.');
                                return;
                            }
                            vm.disabled = true;
                            viewConfirmation.getInstance().result.then(function (cond) {
                                if (cond) {
                                    FleetService.Jobs.moveToArchives(selectedForArchiveJobs.map(job => job.id),
                                    res=>{
                                        toastr.success('Successfully move to archives.');
                                        tableActions.sendRequest({});
                                        vm.disabled = false;
                                    },
                                    err=>{
                                        toastr.error(err.message,err.code);
                                    });
                                }
                            })
                        },
                        
                    },{
                        class: 'btn-success',
                        label: 'Export',
                        onClick: () => {
                            const ids = [];
                            var columns = [];
                            tableData.headers.forEach(item => {
                                columns.push(item.viewName)
                            })
                            const selectedForExportJobs = tableData.data.filter(job => job.isSelected === true);
                            if (!selectedForExportJobs.length) {
                                toastr.warning('No jobs selected to export.');
                                return;
                            }
                            selectedForExportJobs.forEach(item => {
                                ids.push(item.id);
                            }
                            )
                            FleetService.Fleets.jobsExports(columns, ids,
                                res => {
                                    toastr.success('Successfuly exported!');
                                },
                                err => {
                                    toastr.error(err.message, err.code);
                                });

                        }
                    }],
                    selectFilters: [
                        {
                            label: 'Area Filter',
                            ngModel: { label: 'N/A' },
                            width: '150px',
                            dropDownIsFetching: false,
                            selectChoices: [],
                            getChoicesData: function(search){
                                this.dropDownIsFetching = true;
                                FleetService.Areas.getAll(data=>{
                                    this.selectChoices = data.content.map(item=>{
                                        return {
                                            label: item.areaId,
                                            areaName: item.areaId
                                        }
                                    });
                                    this.selectChoices.push({
                                        label: 'N/A',
                                        areaName: ''
                                    });
                                    
                                    this.dropDownIsFetching = false;
                                }, error=>{
                                    this.dropDownIsFetching = false;
                                    toastr.error("Error", error.message);
                                }, {
                                   areaId: search
                                });
                            },
                            onSelect: function(selected){
                                const filter = {
                                    filter: { type: 'text', model: selected.areaName},
                                    filterName: "areaName",
                                }
                                tableData.headers.push(filter);
                                tableActions.sendRequest(tableActions.evaluateFilter(filter));
                            }
                        },
                        {
                            label: 'Route Filter',
                            ngModel: { label: 'N/A' },
                            width: '150px',
                            dropDownIsFetching: false,
                            selectChoices: [],
                            getChoicesData: function(search){
                                this.dropDownIsFetching = true;
                                FleetService.Routes.getRoutes(data=>{
                                    this.dropDownIsFetching = false;
                                    this.selectChoices = data.content.map(item=>{
                                        return {
                                            label: item.name,
                                            routeName: item.name
                                        }
                                    });

                                    this.selectChoices.push({
                                        label: 'N/A',
                                        routeName: ''
                                    });
                                }, error=>{
                                    this.dropDownIsFetching = false;
                                    toastr.error("Error", error.message);
                                }, {
                                    name: search
                                });
                            },
                            onSelect: function(selected){
                                const filter = {
                                    filter: { type: 'text', model: selected.routeName},
                                    filterName: "routeName",
                                }
                                tableData.headers.push(filter);
                                tableActions.sendRequest(tableActions.evaluateFilter(filter));
                            }
                        }
                    ]
                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false
                },
                headers: [{
                    label: 'SELECT',
                    class: 'text-center',
                    filter: {
                        type: 'checkbox'
                    }
                }, {
                    label: 'DATE & TIME',
                    viewName: 'dateTime',
                    filterName: 'createdDate',
                    filter: {
                        type: 'datePicker',
                        url: '',
                        class: 'filter-date',
                        toModel: '',
                        fromModel: '',
                        useArray: true,
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'SORT CODE',
                    viewName: 'sortCode',
                    filterName: 'route.area.sortCode',
                    filter: {
                        type: 'text',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.sortName);
                    }
                }, {
                    label: 'JOB ID',
                    viewName: 'jobId',
                    filterName: 'jobId',
                    filter: {
                        type: 'text',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'BBA REFERENCE NO.',
                    viewName: 'bbaReferenceNumber',
                    filterName: 'bbaReferenceNumber',
                    filter: {
                        type: 'text',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    }
                }, {
                    label: 'CONSIGNMENT',
                    viewName: 'consignmentId',
                    filterName: 'consignmentId',
                    filter: {
                        type: 'text',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'STATUS',
                    viewName: 'jobStatusFormatted',
                    filterName: 'jobStatus',
                    filter: {
                        type: 'select2',
                        placeholder: 'Search',
                        items: [{
                            value: jobStatusesValue.unassigned,
                            viewName: jobStatuses[jobStatusesValue.unassigned.toLowerCase()]
                        }, {
                            value: jobStatusesValue.forapproval,
                            viewName: jobStatuses[jobStatusesValue.forapproval.toLowerCase()]
                        }, {
                            value: jobStatusesValue.pending,
                            viewName: jobStatuses[jobStatusesValue.pending.toLowerCase()]
                        }, {
                            value: jobStatusesValue.accepted,
                            viewName: jobStatuses[jobStatusesValue.accepted.toLowerCase()]
                        }, {
                            value: jobStatusesValue.received,
                            viewName: jobStatuses[jobStatusesValue.received.toLowerCase()]
                        }, {
                            value: jobStatusesValue.inprogress,
                            viewName: jobStatuses[jobStatusesValue.inprogress.toLowerCase()]
                        }, {
                            value: jobStatusesValue.delivered,
                            viewName: jobStatuses[jobStatusesValue.delivered.toLowerCase()]
                        }, {
                            value: jobStatusesValue.failed,
                            viewName: jobStatuses[jobStatusesValue.failed.toLowerCase()]
                        }, {
                            value: jobStatusesValue.notyetstarted,
                            viewName: jobStatuses[jobStatusesValue.notyetstarted.toLowerCase()]
                        }],
                        onSelect: function (header) {
                            const filter = {};
                            filter[header.filterName] = header.filter.model;
                            tableActions.sendRequest(filter);
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'ORIGIN POSTCODE',
                    viewName: 'originPostcode',
                    filterName: 'sourceAddress.locationCode',
                    width: '150px',
                    filter: {
                        type: 'text',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'ORIGIN SUBURB',
                    viewName: 'originSuburb',
                    filterName: 'sourceAddress.locationName',
                    width: '150px',
                    filter: {
                        type: 'text',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'DESTINATION POSTCODE',
                    viewName: 'destinationPostcode',
                    filterName: 'destinationAddress.locationCode',
                    width: '165px',
                    filter: {
                        type: 'text',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'DESTINATION SUBURB',
                    viewName: 'destinationSuburb',
                    filterName: 'destinationAddress.locationName',
                    width: '150px',
                    filter: {
                        type: 'text',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'PACKAGES',
                    viewName: 'packagesFormatted',
                    filterName: 'packages',
                    width: '100px'
                }, {
                    label: 'PACKAGES SCANNED',
                    viewName: 'scanSummary'
                }, {
                    label: 'DRIVER',
                    width: '200px',
                    viewName: 'driverName',
                    filterName: 'driverId',
                    sortName: 'driver.firstName',
                    filter: {
                        type: 'autoComplete',
                        placeholder: 'Search',
                        viewName: 'driverName',
                        filterBy: 'id',
                        items: [],
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        },
                        refresh: function (model) {
                            const defer = $q.defer();
                            let filterItems = this.items;
                            FleetService.Drivers.getAll((data) => {
                                filterItems.length = 0;
                                angular.forEach(data.content, (driver) => {
                                    driver.driverName = driver.firstName + ' ' + driver.lastName;
                                    filterItems.push(driver);
                                });
                                defer.resolve();
                            }, (error) => {
                                defer.reject();
                            }, { size: 30, firstName: model });
                            return defer.promise;
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.sortName);
                    }
                }, {
                    label: 'VEHICLE ID ',
                    width: '200px',
                    viewName: 'vehicleId',
                    filterName: 'driver.currentVehicle.vehicleId',
                    filter: {
                        type: 'autoComplete',
                        placeholder: 'Search',
                        viewName: 'vehicleId',
                        filterBy: 'vehicleId',
                        items: [],
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        },
                        refresh: function (model) {
                            const defer = $q.defer();
                            let filterItems = this.items;
                            FleetService.Vehicles.getAll((data) => {
                                filterItems.length = 0;
                                angular.forEach(data.content, (vehicle) => {
                                    filterItems.push(vehicle);
                                });
                                defer.resolve();
                            }, (error) => {
                                defer.reject();
                            }, { size: 30, vehicleId: model });
                            return defer.promise;
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Company',
                    width: '200px',
                    viewName: 'companyName',
                    filterName: 'companyId',
                    filter: {
                        type: 'autoComplete',
                        placeholder: 'Search',
                        viewName: 'name',
                        filterBy: 'id',
                        items: [],
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        },
                        refresh: function (model) {
                            const defer = $q.defer();
                            let filterItems = this.items;
                            ClientService.Company.getAll((data) => {
                                filterItems.length = 0;
                                angular.forEach(data.content, (vehicle) => {
                                    filterItems.push(vehicle);
                                });
                                defer.resolve();
                            }, (error) => {
                                defer.reject();
                            }, { size: 30, name: model });
                            return defer.promise;
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }],
                data: [],
                extractTable: function (form) {

                },
                resetFilters: () => {
                    tableActions.resetFilters();
                },
                onInit: function () {
                    const filter = loadUnassignedByDefault ? { jobStatus : jobStatusesValue.unassigned} : {};
                    tableActions.sendRequest(filter);
                }
            };

            // load unassigned by default
            if(loadUnassignedByDefault) {
                tableData.headers.forEach(data=> {
                    if(data.label == "STATUS") {
                        data.filter.model = {
                            value: jobStatusesValue.unassigned, 
                            viewName: jobStatuses[jobStatusesValue.unassigned.toLowerCase()]
                        }
                    }
                });
            }

            // show assign button
            if(showAssignButton) {
                const assignButton = {
                    class: 'btn-primary', 
                    label: 'ASSIGN SELECTED', 
                    onClick: function(){
                        const selectedDrivers = tableData.data.filter(job => job.isSelected === true);
                        const vm = this;
                        if(selectedDrivers.length != 0){
                            const modal = $uibModal.open({
                                animation: true,
                                ariaLabelledBy: 'modal-title',
                                ariaDescribedBy: 'modal-body',
                                templateUrl: '/templates/pages/jobs/add-ons/assignDriverModal.html',
                                controller: 'AssignDriverModalController',
                                controllerAs: 'vm',
                                windowClass: 'full-height-modal assign-job-modal',
                                size: 'sm',
                                appendTo: $('body'), 
                                resolve: {
                                    selectedJobs: function (){
                                        return selectedDrivers;
                                    }
                                }
                            });

                            modal.result.then(function(data){
                                refreshTable();
                            });
                        }
                    }
                }

                if(tableData.optionAddOns.buttons != null) {
                    tableData.optionAddOns.buttons.push(assignButton);
                }
            }

            const tableActions = new TableLiteFactory(tableData,
                {
                    serviceCallback: angular.getObjVal(params, 'area.id') ? FleetService.Areas.getAreaJobs : FleetService.Jobs.getAll,
                    callbackFormat: angular.getObjVal(params, 'area.id') ? ['id', 'success', 'error', 'filter'] : ['success', 'error', 'filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    paramId: angular.getObjVal(params, 'area.id'),
                    defaultFilters: angular.extend({
                        size: 20,
                        page: 0,
                        sort: 'createdDate,desc',
                        adhoc: true,
                        type: 'P2P',
                        'route.id': angular.getObjVal(params, 'route.id'),
                    }, params.filters || {})
                }
            );

            function buildTableData(data) {
                /*** START - Building of Data ***/
                if (!data)
                    return tableData;
                tableActions.initializeTableData(data);
                let search = '';
                if (params.referrer === 'route') {
                    search = `?routeId=${params.route.id}`
                }
                if (params.referrer === 'area') {
                    search = `?areaId=${params.area.id}`
                }
                angular.forEach(data.content, function (item) {
                    const batch = item.batch || {};
                    const weightUnit = Units.getWeightUnit($rootScope.GlobalProfile.office.weightUnit);
                    const totalPackagesCubicWeightFormatted = `(${batch.totalPackagesCubicWeight} ${weightUnit})`;
                    const batchFormatted = item.batchId === 0 ? 'N/A (AD HOC Job)' : null;
                    item.href = `/jobs/details/${item.id}${search}`;
                    item.bbaReferenceNumber = item.bbaReferenceNumber || 'N/A';
                    item.originPostcode = angular.getObjVal(item, 'sourceAddress.location.code');
                    item.originSuburb = angular.getObjVal(item, 'sourceAddress.location.name');
                    item.destinationPostcode = angular.getObjVal(item, 'destinationAddress.location.code');
                    item.destinationSuburb = angular.getObjVal(item, 'destinationAddress.location.name');
                    item.packagesFormatted = {
                        type: 'multiLine',
                        list: item.packages ? item.packages.map(pack => {
                            const mUnit = Units.getMeasureUnit(pack.measureUnit);
                            const wUnit = Units.getWeightUnit(pack.weightUnit);
                            return pack.name || (`${pack.length} ${mUnit} x ${pack.length} ${mUnit} x ${pack.height} ${mUnit} / ${pack.weight} ${wUnit} (${pack.quantity} packs)`)
                        }) : []
                    };
                    item.dateTime = $filter('bbaDate')(item.createdDate, true);
                    item.driverName = `${angular.getObjVal(item, 'driver.firstName') || 'N/A'} ${angular.getObjVal(item, 'driver.lastName') || ''}`;
                    item.vehicleId = angular.getObjVal(item, 'driver.currentVehicle.vehicleId') || 'N/A';
                    item.jobStatusFormatted = jobStatuses[(item.jobStatus || 'unassigned').toLowerCase()];
                    item.companyName = angular.getObjVal(item, 'company.name');
                    item.sortCode = angular.getObjVal(item, 'sortCode') || 'N/A';
                    item.scanSummary = ScanSummaryHelperService.getScanSummary(item.scanSummary);
                    tableData.data.push(item);
                });
            }

            function refreshTable() {
                tableActions.sendRequest({});
            }
            this.tableData = tableData;
            this.refreshTable = refreshTable;
        }
    }
})();


// WEBPACK FOOTER //
// ./js/services/tables/P2PJobsTableService.js